import ProductPageLayout from '@/pages/products/components/ProductPageLayout';

export default function ScallopsPage() {
  return (
    <ProductPageLayout>
      <div className="relative">
        {/* Page background */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          
        </div>

        {/* Content section */}
              <section className="relative z-10 w-full">
                  {/* Background */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                      <img
                          src="/images/k2.png"
                          alt="Slide7"
                          className="w-full h-full object-cover object-center blur-md scale-105"
                      />


                      <div className="absolute inset-0 bg-black/50"></div>
                  </div>

          <div className="relative z-10 w-full max-w-[980px] mx-auto px-6 md:px-10 py-10">
            {/* Script tagline */}
            <p className="font-script text-white text-lg md:text-xl text-center mb-4">
              America&#39;s One-Stop-Shop for Seafood
            </p>

            {/* Header Image + H1 - source DOM has image before H1 */}
            <div className="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8 mb-2">
              <div className="flex-shrink-0 order-2 md:order-1">
                <img
                                  src="/images/po3.png"
                  alt="Product Header Scallop"
                  className="w-[592px] max-w-full h-auto"
                />
              </div>
              <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl tracking-[0.2em] leading-none uppercase order-1 md:order-2">
                Wholesale<br />SCALLOPS
              </h1>
            </div>

            {/* Subheading */}
            <h5 className="font-heading text-white text-lg md:text-xl tracking-[0.15em] leading-snug mb-6 uppercase">
              Wholesale SCALLOPS<br />from Finest Kind Seafood LLC
            </h5>

            {/* First paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-6">
              Finest Kind Seafood LLC is a premier distributor of hard bottom, north Atlantic sea scallops. Although we also purchase and sell bay scallops, this is a truly seasonal item around New England, with government regulations on when the season opens and as well as on quotas. Since we only source the best products on the market – we strictly buy local north Atlantic scallops – which are the best in the world, therefore placing our primary focus on our North Atlantic sea scallops, of which we are fully stocked with year-round.
            </p>

            {/* Paragraph 2 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              Our cold-water, wholesale scallops are prized for their firm texture and sweet taste. Finest Kind Seafood LLC is one of the largest purchasers of fresh scallops on the New Bedford, MA auction, which is the epicenter for sea scallop trade in the United States. We rush the scallops to our plant in Fall River, where our experienced staff hand grade, rinse and pack them for our customers in tins, plastic tubs or linen sacks. Our graded, fresh, wholesale scallops are guaranteed to give our customers the quality they expect.
            </p>

            {/* Paragraph 3 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              As mentioned, we carry local bay scallops whenever possible, but the majority of our scallop business is centered around our fresh sea scallops. Despite this fact, we still purchase and sell bay&#39;s whenever possible, and that usually falls right around November 1st when the season opens on Nantucket, the Vineyard, and on the Cape. This will last into the winter until the cold weather eventually freezes things up and brings the season to a close. Bay scallops are typically smaller and sweeter than most sea scallops.
            </p>

            {/* Zoom image + final paragraph */}
            <div className="relative">
              <img
                              src="/images/po4.png"
                alt="Wholesale Scallop Zoom"
                className="float-right ml-6 mb-4 w-[260px] md:w-[350px] h-auto"
              />
              <p className="text-white text-[13px] leading-relaxed mb-5">
                North Atlantic sea scallops are globally considered the market standard for scallops. These scallops are predominantly caught on or around Georges Bank, and brought to shore along the northeast United States and Canada. Being so close to the source, alongside our ability to have our buyers on the docks at the New Bedford auction daily, ensures our customers the freshest North Atlantic sea scallops on the market. Furthermore, our volume buying power enables us to bring in massive amounts of wholesale scallops daily, which cuts the price down for our customers and ensures them not only the best quality on the market, but the sharpest prices as well.
              </p>
              <div className="clear-both" />
            </div>
          </div>
        </section>
      </div>
    </ProductPageLayout>
  );
}